export default {
  tradeInOptionYesDescription: {
    id: 'product_page_customization_step_trade_in_option_yes_description',
    defaultMessage:
      'We’ll buy back your old tech for cash, which could make today’s total more like {price} after your trade-in',
  },
}
